const state = {
  appId: '',
  treeData: [],
  code:'',
  businessSystemEnter:false,
  url:''
}

const actions = {
  setAppTreeData({commit}, data) {
    commit('treeData', data)
  },

  setAppTreeItemName({commit}, params) {
    commit('updateName', params)
  },
  setAppCode({commit}, data) {
    commit('appCode', data)
  },
  setBusinessSystemEnter({commit},data){
    commit('businessSystemEnter', data)
  },
  setModuleUrl({commit}, data) {
    commit('moduleUrl', data)
  }
}

const getters = {
  getAppTreeData: function (state, getters) {
    return function (appId) {
      if (appId == state.appId) {
        return state.treeData
      } else {
        state.appId ='';
        state.treeData =[];
        return undefined;
      }
    }
  },
  getAppCode: state => state.code,
  isBusinessSystemEnter: state => state.businessSystemEnter,
  getModuleUrl: state => state.url,
}

const mutations = {
  ['treeData'](state, data) {
    state.appId = data.appId;
    state.treeData = data.data;
  },
  ['updateName'](state, params) {
    function changeTreeItemName(data,params){
      for(var i=0;i<data.length;i++){
        var v=data[i];
        if(v.id==params.id){
          v.text=params.name;
          break;
        }
        if(v.children && v.children.length>0){
          changeTreeItemName(v.children,params);
        }
      }
    }
    if(state.treeData)
      changeTreeItemName(state.treeData,params);
  },
  ['appCode'](state, data) {
    state.code = data.code;
  },
  ['businessSystemEnter'](state, data) {
    state.businessSystemEnter = data.businessSystemEnter;
  },
  ['moduleUrl'](state, data) {
    state.url = data.url;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/common/vuex/modules/app/appTreeData.js